import type { IModule } from "angular";
import { module } from "angular";

export const app: IModule = module("mmModels", []);
